import { useEffect, useState } from "react";

import { fetchContractDetails, fetchContractDetailsById } from "../api/fetchContractDetails";

const usePlans = (chassis: string, odometer: number, hourmeter: number, truckerPayPlanId: string) => {
    const [truckerPayPlanName, setTruckerPayPlanName] = useState<string | null>(null);

    useEffect(() => {
        if (truckerPayPlanId) {
            fetchContractDetailsById(truckerPayPlanId)
                .then((data) => setTruckerPayPlanName((data.name ?? "") + " - " + (data.contract ?? "")))
                .catch(() => setTruckerPayPlanName(""));
        } else if (chassis) {
            fetchContractDetails({ chassis, odometer, hourmeter } as any)
                .then((data) => setTruckerPayPlanName((data.name ?? "") + " - " + (data.contract ?? "")))
                .catch(() => setTruckerPayPlanName(""));
        }

    }, [chassis, odometer, hourmeter, truckerPayPlanId]);

    return {
        truckerPayPlanName
    }
}

export default usePlans;